import { AppContext } from 'state/context'
import { useContextSelector } from 'use-context-selector'

import { createUserSelectorCallback } from 'utils/createUserSelectorCallback'

export const useCompanyManagers = () => {
  return useContextSelector(
    AppContext,
    createUserSelectorCallback('companies', 'companyManagers'),
  )
}

export const useCompanyManagersNew = (companyId: number | undefined) => {
  return useContextSelector(
    AppContext,
    ([{companies}])=>{
      const companyList =  companies.filter(company => company.id == companyId)?.[0]?.companyManagers
      return companyList ? companyList : []
    }
  )
}

export const useOtherRoles = (roleType:any) => {
  return useContextSelector(
    AppContext, ([{ project_managers, signatories, sub_contractors, super_foremans, project_coordinators }]) =>{
      if(roleType == 'project_managers')
        return project_managers
      else if(roleType == 'sub_contractors')
        return sub_contractors
      else if(roleType == 'super_foremans')
        return super_foremans
      else if(roleType == 'project_coordinators')
        return project_coordinators
    }
  )
}

export const usePermissions = (userType:any)=> {
  return useContextSelector(
    AppContext, ([{ permissionsList }]) => {
      // return permissionsList ? permissionsList : {}
      return permissionsList.filter((permission:any)=>{
        if (userType == 1 && permission['role_class_name'] == 'CompanyManagerRole')
          return permission
        else if (userType == 2 && permission['role_class_name'] == 'ProjectManagerRole')
          return permission
        else if (userType == 3 && permission['role_class_name'] == 'SuperForemanRole')
          return permission
        else if (userType == 4 && permission['role_class_name'] == 'SubContractorRole')
          return permission
        else if (userType == 5 && permission['role_class_name'] == 'ProjectCoordinatorRole')
          return permission
      })?.[0]?.['permissions']
    }
  )
}

export const useNewPermissions = (userType:any)=> {
  return useContextSelector(
    AppContext, ([{ permissionsList }]) => {
      // return permissionsList ? permissionsList : {}
      return permissionsList.filter((permission:any)=>{
        if (userType == 1 && permission['role_class_name'] == 'CompanyManagerRole')
          return permission
        else if (userType == 2 && permission['role_class_name'] == 'ProjectManagerRole')
          return permission
        else if (userType == 3 && permission['role_class_name'] == 'SuperForemanRole')
          return permission
        else if (userType == 4 && permission['role_class_name'] == 'SubContractorRole')
          return permission
        else if (userType == 5 && permission['role_class_name'] == 'ProjectCoordinatorRole')
          return permission
      })?.[0]
    }
  )
}